;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  eah.ninjaFormsAJAX = (function () {
    const initialize = function () {
      function alterSuccessMessage (e, response) {
        // console.log("Running the custom handler.");
        // console.log(response);
        if ((response.errors === false) && $('.success-concierge').length) {
          const ldscData = JSON.parse($('.concierge-json').text())
          if (ldscData.image_url.length > 0) {
            $('.success-concierge').append('<div class="team-member-image-wrapper"><div class="team-member-image" style="background-image: url(\'' + ldscData.image_url + '\');"></div></div>')
          }
          if (ldscData.name.length > 0) {
            $('.success-text .team-member-name').text(ldscData.name)
            $('.success-text .team-member-title').text(ldscData.title)
            // $ldsc.text("I got changed!");
          }
        } else {
          console.log('Success message hasn\'t rendered yet...')
        }
      }

      if ($('.js-concierge').length) {
        const formId = 'form#' + $('.web-concierge-wrapper form').attr('id') + '.ninja-forms-form'

        console.log('adding custom submitResponse for ', formId)
        $(formId).on('beforeSubmit.addSubmitHandler', function (e, response) {
          // It is silly that this is how we have to ensure that our custom submitResponse handler executes after the default.
          $(this).on('submitResponse.doTheThing', alterSuccessMessage)
        })
      }
    }

    return {
      initialize: initialize
    }
  }())

  $(function () {
    eah.ninjaFormsAJAX.initialize()
  })
}(jQuery, window))
